import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["table"];

  connect() {
    console.log("Sortable table controller connected");
  }

  sort(event) {
    const header = event.currentTarget;
    const sortType = header.dataset.sortType || "string";
    const sortCol = parseInt(header.dataset.sortCol);
    let isAsc = header.dataset.sortAsc === "true";

    // Toggle sort direction
    isAsc = !isAsc;
    header.dataset.sortAsc = isAsc.toString();

    const tbody = this.tableTarget.querySelector("tbody");
    const rows = Array.from(tbody.querySelectorAll("tr"));

    rows.sort((a, b) => {
      const aCell = a.children[sortCol];
      const bCell = b.children[sortCol];

      const aVal = aCell.dataset.sortValue || aCell.innerText.trim();
      const bVal = bCell.dataset.sortValue || bCell.innerText.trim();

      if (sortType === "date") {
        return isAsc
          ? new Date(aVal) - new Date(bVal)
          : new Date(bVal) - new Date(aVal);
      } else {
        return isAsc ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
      }
    });

    // Append rows back to tbody in sorted order
    tbody.append(...rows);

    // Reset arrows
    const allHeaders = this.element.querySelectorAll("th[data-action]");
    allHeaders.forEach((th) => {
      const icon = th.querySelector(".sort-icon");
      if (icon) {
        icon.innerHTML = "↕️";
        icon.classList.add("has-text-grey-light");
      }
    });

    // Set arrow for current
    const currentIcon = header.querySelector(".sort-icon");
    if (currentIcon) {
      currentIcon.innerHTML = isAsc ? "⬆️" : "⬇️";
      currentIcon.classList.remove("has-text-grey-light");
    }
  }
}
